import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { UserRoleService } from '../core/services/user-role.service';
import { ReviewType } from '../core/models/user-access.model';

@Component({
  standalone: true,
  selector: 'app-planning',
  imports: [RouterLink, FormsModule, CommonModule],
  templateUrl: './planning.component.html',
  styleUrl: './planning.component.css',
})
export class PlanningComponent implements OnInit {
  selectedReview: ReviewType | null = null;
  showPrivacyDialog = false;
  privacyAcknowledged = false;
  reviewOptions: ReviewType[] = [];
  planningImageLoaded = false;

  constructor(private router: Router, private userRoleService: UserRoleService) {}

  ngOnInit() {
    this.reviewOptions = this.userRoleService.reviewTypes
      .slice()
      .sort((a, b) => a.DisplayOrder - b.DisplayOrder);
    const img = new Image();
    img.onload = () => { this.planningImageLoaded = true; };
    img.onerror = () => { this.planningImageLoaded = true; };
    img.src = 'images/Planning_image.png';
  }

  getReviewTypeLabel(reviewType: ReviewType): string {
    return reviewType.ReviewTypeName.replace(/^Go\s+Live Review$/i, 'Go-Live Review');
  }

  addNewReview() {
    if (!this.selectedReview) return;
    const normalized = this.selectedReview.ReviewTypeName.toLowerCase().replace(/[\s\-_]/g, '');
    let route: string;
    if (normalized.includes('golive')) {
      route = '/planning/go-live-review';
    } else if (normalized.includes('ondemand')) {
      route = '/planning/on-demand-review';
    } else if (normalized.includes('specialproject')) {
      route = '/planning/special-project-review';
    } else {
      route = '/planning/standard-review';
    }
    this.router.navigate([route], { state: { reviewType: this.selectedReview } });
  }

  openPrivacyDialog(): void {
    this.privacyAcknowledged = false;
    this.showPrivacyDialog = true;
  }

  closePrivacyDialog(): void {
    this.showPrivacyDialog = false;
  }

  proceedWithImport(): void {
    if (!this.privacyAcknowledged) return;
    this.showPrivacyDialog = false;
    this.router.navigate(['/planning/import-standard-review']);
  }
}